import SearchInput from './SearchInput';
import './search-input.scss';

export default SearchInput;
